<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Worker Sessions</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <span class="subheading"><b>Filters:</b></span>
                        <v-icon v-if="showFilters" @click="showFilters = !showFilters">fal fa-chevron-up</v-icon>
                        <v-icon v-if="!showFilters" @click="showFilters = !showFilters">fal fa-chevron-down</v-icon>
                    </v-layout>
                        <v-form v-model="valid" v-if="showFilters" @submit.prevent>
                    <v-layout wrap>
                        <v-flex xs11>
                            <v-layout wrap>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Id" v-model="id" :rules="[rules.numeric]"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-autocomplete
                                    v-model="orgId"
                                    :items="organizations"
                                    label="Organization"
                                        item-text="text"
                                        item-value="value">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Ended" v-model="ended" :items="endedItems"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Valid" v-model="validItemsFlag" :items="validItems"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Active" v-model="active" :items="activeItems"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="App Type" v-model="appType"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Version" v-model="version"></v-text-field>
                                </v-flex>
                                <!-- <v-flex xs2 ml-4>
                                    <v-text-field label="Misc Data" v-model="miscData"></v-text-field>
                                </v-flex> -->
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                            <button onsubmit="false" class="btn btn-primary" @click="applyFilters" :disabled="!valid">Apply</button>
                            <button onsubmit="false" class="btn btn-default" @click="resetFilters">Reset</button>
                        </v-flex>
                    </v-layout>
                        </v-form>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="workerSessions.content"
                              :loading="loading"
                              :headers="headers"
                              :options.sync="pagination"
                              :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50, 100]}"
                              :server-items-length="totalItems" class="elevation-1"
                            >
                              <template v-slot:item.startDate="{item}">
                                <td>{{formatDateTime(item.startDate)}}</td>
                              </template>
                              <template v-slot:item.endDate="{item}">
                                <td>{{formatDateTime(item.endDate)}}</td>
                              </template>
                              <template v-slot:item.updatedDate="{item}">
                                <td>{{formatDateTime(item.updatedDate)}}</td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>

                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import Utility from './utility'
export default {
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        }
    },
    data() {
        return {
            workerSessions: {
                "content": [],
                "pageable": {
                    "sort": {
                         "sorted": true,
                         "unsorted": false,
                         "empty": false
                    },
                    "pageNumber": 0,
                    "pageSize": 10,
                    "offset": 0,
                    "paged": true,
                    "unpaged": false
                },
                "totalPages": 0,
                "last": true,
                "totalElements": 0,
                "sort": {
                    "sorted": true,
                    "unsorted": false,
                    "empty": false
                },
                "number": 0,
                "first": true,
                "numberOfElements": 0,
                "size": 10,
                "empty": true
            },
            loading: false,
            search: '',
            pagination : {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    itemsPerPage: 10,
                    sortBy: ["updatedDate"]
            },
            totalItems: 0,
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                // {text: 'Org Id', align: 'left', sortable: true, value: 'org.id'},
                // {text: 'Org Name', align: 'left', sortable: true, value: 'org.name'},
                {text: 'App Type', align: 'left', sortable: true, value: 'appType'},
                {text: 'Version', align: 'left', sortable: true, value: 'version'},
                {text: 'Start Date', align: 'left', sortable: true, value: 'startDate'},
                {text: 'End Date', align: 'left', sortable: true, value: 'endDate'},
                {text: 'Updated Date', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Updated By', align: 'left', sortable: true, value: 'updatedBy'},
                // {text: 'Misc Data', align: 'left', sortable: true, value: 'miscData'}
            ],
            orgId: null,
            ended: null,
            validItemsFlag: null,
            active: null,
            appType: null,
            version: null,
            miscData: null,
            id: null,
            endedItems:[
                {text: 'All', value: null},
                {text: 'Ended only', value: true},
                {text: 'Non-ended only', value: false}
            ],
            validItems:[
                {text: 'All', value: null},
                {text: 'Valid only', value: true},
                {text: 'Non-valid only', value: false}
            ],
            activeItems:[
                {text: 'All', value: null},
                {text: 'Active only', value: true},
                {text: 'Inactive only', value: false}
            ],
            rules: {
                numeric: value => !value || Number.isInteger(+value) || 'Invalid format'
            },
            valid: false,
            showFilters: true
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        }
    },
    methods: {
        async refresh(pagination) {

            const { page, itemsPerPage, sortBy, sortDesc } = pagination

            let sort = ""
            if (sortBy && sortBy.length) {
                sort = sortBy[0] + "," + (sortDesc && sortDesc.length && sortDesc[0] ? 'desc' : 'asc')
            }

            let id = this.id ? +this.id : this.id

            let filter = Utility.buildQueryString(['id', 'org_id', 'app_type', 'misc_data', 'version', 'ended', 'valid', 'active'],
                              [id, this.orgId, this.appType, this.miscData, this.version, this.ended, this.validItemsFlag, this.active],
                              ['app_type', 'version'])

            this.loading = true

            this.workerSessions = await this.$store.dispatch('crossorg/getWorkerSessions',
                {filter, size: itemsPerPage || 10, page: page ? page - 1 : 0, sort})

            this.totalItems = this.workerSessions.totalElements

            this.loading = false
        },
        formatDateTime(val) {
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async resetFilters() {
            this.orgId = null
            this.ended = null
            this.validItemsFlag = null
            this.active = null
            this.appType = null
            this.version = null
            this.miscData = null
            this.id = null

            await this.refresh(this.pagination)

        },
        async applyFilters() {
            await this.refresh(this.pagination)
        }
    }
}
</script>
